import { render, staticRenderFns } from "./LiveServer.vue?vue&type=template&id=57e6f4bc&scoped=true&"
import script from "./LiveServer.vue?vue&type=script&lang=js&"
export * from "./LiveServer.vue?vue&type=script&lang=js&"
import style0 from "./LiveServer.vue?vue&type=style&index=0&id=57e6f4bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e6f4bc",
  null
  
)

export default component.exports